import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { axiosInstance } from '../../shared/api/axios-instance';
import { createPathParams } from '../../shared/utils/create-path-params/create-path-params.util';
import { Endpoints } from '../../shared/utils/endpoints-file.utils';
import { AppDto } from '../dtos/app.dto';
import { AppModel } from '../models/app.model';
import { mapAppDtoToAppModel } from '../utils/mapping.utils';

export const getAppDetailsById = createAsyncThunk<
  AppModel,
  number,
  Record<string, unknown>
>('apps/get-app-by-id', async (appId: number): Promise<AppModel> => {
  const url: string = createPathParams<'appId'>(Endpoints.APP_BY_ID, { appId });
  const { data }: AxiosResponse<AppDto> = await axiosInstance.get(url);
  return mapAppDtoToAppModel(data);
});
